/* eslint-disable */
export default ({$el}) => $el.map(function() {
	return $(this).css('background-image').replace(/^url\(\"?(.*?)\"?\)$/g, '$1');
});